import { SET_FORM_ERRORS, CLEAR_FORM_ERRORS, RESET_SERVER_ERRORS } from '../actions/form'

// Initial state
const initialState = {
  serverErrors: null
}

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_ERRORS:
      return {
        ...state,
        serverErrors: action.payload
      }
    case CLEAR_FORM_ERRORS:
    case RESET_SERVER_ERRORS:
      return {
        ...state,
        serverErrors: null
      }
    default:
      return state
  }
}

export default formReducer
